module.exports = __webpack_public_path__ + "img/icone-checklist.a1d01eac.svg";